import { genericPage, getServerSidePropsHelper } from 'components/3catinfo/Page';
import { useRouter } from 'next/router';

const path = ['web', process.env.FOLDER_LAYOUTS_CORPORATIU, 'tv3', 'marato', 'totes-maratons'];

const Pagina = (props) => {
    const router = useRouter();
    return genericPage(props, router, path);
};

export async function getServerSideProps(context) {
    context.query.lang = 'ca';
    return getServerSidePropsHelper(context, { slugs: path, id: 510 });
}

export default Pagina;
